import { safeInitTelegram } from "utils/tgWebApp"

declare global {
  interface Window {
    Telegram: {
      WebApp: TelegramWebApp
      Login: any
    }
  }
}

export type ImpactOccurredType = "light" | "medium" | "hard" | "rigid" | "soft"
export type NotificationOccurredType = "error" | "success" | "warning"

export interface TelegramWebApp {
  initData: string
  initDataUnsafe: Record<string, any>

  version: string
  platform: string
  colorScheme: "light" | "dark"
  themeParams: Record<string, string>

  isExpanded: boolean
  viewportHeight: number
  viewportStableHeight: number

  isFullscreen?: boolean

  MainButton: {
    text: string
    color: string
    textColor: string
    isVisible: boolean
    isProgressVisible: boolean
    isActive: boolean
    show(): void
    hide(): void
    enable(): void
    disable(): void
    showProgress(leaveActive?: boolean): void
    hideProgress(): void
    setText(text: string): void
    onClick(cb: () => void): void
    offClick(cb: () => void): void
  }

  BackButton: {
    isVisible: boolean
    show(): void
    hide(): void
    onClick(cb: () => void): void
    offClick(cb: () => void): void
  }

  HapticFeedback?: {
    impactOccurred(strength: ImpactOccurredType): void
    notificationOccurred(type: NotificationOccurredType): void
    // selectionChanged(): void
  }

  // Основні методи
  ready(): void
  expand(): void
  close(): void

  // Кольори
  setHeaderColor(color: string): void
  setBackgroundColor(color: string): void

  // Fullscreen API
  requestFullscreen?(): void
  exitFullscreen?(): void

  enableClosingConfirmation(): void
  disableClosingConfirmation(): void

  // Події
  onEvent?(event: TelegramEventType, callback: () => void): void
  offEvent?(event: TelegramEventType, callback: () => void): void

  // Other methods
  disableVerticalSwipes?(): void
  enableVerticalSwipes?(): void
  lockOrientation?(): void
  unlockOrientation?(): void
  openTelegramLink(url?: string): void
  openInvoice(
    url: string,
    callback?: (status: "paid" | "cancelled" | "failed") => void
  ): void
}

type TelegramEventType =
  | "themeChanged"
  | "viewportChanged"
  | "mainButtonClicked"
  | "backButtonClicked"
  | "fullscreenChanged"

export const initTelegramData = () => {
  if (import.meta.env.VITE_NODE_ENV === "local") {
    const USER = import.meta.env.VITE_DEV_INITDATA_NAME || "Daniil"

    const USERS_DATA = {
      Denys: {
        initData:
          "query_id=AAFvYK4WAAAAAG9grhZuQ0vq&user=%7B%22id%22%3A380526703%2C%22first_name%22%3A%22Denys%22%2C%22last_name%22%3A%22%22%2C%22username%22%3A%22DenysTymchenko%22%2C%22language_code%22%3A%22en%22%2C%22allows_write_to_pm%22%3Atrue%7D&auth_date=1729865602&hash=68f897e88cdcea493d98d1c09bc8a7da1b8c90a120de7ba6b0d925c19ba66763",
        id: 380526703,
        photo_url:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRHF-lTW4EB294JIZyN4hgD_GWAsaGuypQ6qQ&s"
      },
      Evgeniy: {
        initData:
          "query_id=AAGEzmwLAAAAAITObAtsjvbf&user=%7B%22id%22%3A191680132%2C%22first_name%22%3A%22%D0%96%D0%B5%D0%BA%D0%B0%22%2C%22last_name%22%3A%22%22%2C%22username%22%3A%22jtokan%22%2C%22language_code%22%3A%22ru%22%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2FW2NEMxJjw-ykSJTYsHD2Ijy4NiZkkL-1V6GLRucggGA.svg%22%7D&auth_date=1731586164&hash=c92813db6ce900fc71315cd2b8ddcb444ab03de9164dfc47def2d6112c1af4b3",
        id: 191680132
      },
      Dmytro: {
        initData:
          "AAFOJtI0AAAAAE4m0jSZ-e1Y&user=%7B%22id%22%3A886187598%2C%22first_name%22%3A%22Dmytro%22%2C%22last_name%22%3A%22Iudin%22%2C%22username%22%3A%22dmitriyiudin%22%2C%22language_code%22%3A%22en%22%2C%22allows_write_to_pm%22%3Atrue%7D&auth_date=1730973462&hash=6d2043d11bfbcb7cf5a54392fb4d35af98fa154d8ce44a2c894117343b7e55c3",
        id: 886187598
      },
      Oleksandr: {
        initData:
          "query_id=AAHjLrRnAwAAAOMutGdZ1TbF&user=%7B%22id%22%3A8182312675%2C%22first_name%22%3A%22Alex%22%2C%22last_name%22%3A%22%22%2C%22language_code%22%3A%22uk%22%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2FgI1xdgevYb5JN7uyz0pUQgL3_0b7x_slBrPqiiaRLD6UmSy62WPrB5Slan2Xx_Uh.svg%22%7D&auth_date=1732526386&signature=vBItAodil-J8Fs-kjjmZPBeLKEXY_wgV9Tp0V44LhiIlbFiO4UwXC2yiCPtkTYHslg-RopXZfhJXQLlnB9Q4Aw&hash=0dc9022805043c79cd2b652871fdaa3d78bd255a60193b5d7087323246834d11",
        id: 8182312675
      },
      Oleksandr2: {
        initData:
          "query_id=AAG9QuUSAAAAAL1C5RKnp0xY&user=%7B%22id%22%3A317014717%2C%22first_name%22%3A%22Alex%22%2C%22last_name%22%3A%22%22%2C%22username%22%3A%22alexc0re%22%2C%22language_code%22%3A%22uk%22%2C%22is_premium%22%3Atrue%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2F5tWNWjzkxjrj_pNdz2bf7lmAyPzrChE9NIIl4JVFLDg.svg%22%7D&auth_date=1732632150&signature=YtDa8F6Bj5CGItuhHiZ36iHGsjwPkQXzm4CXKJ2j-Gwre6LcxVBzfUoyVWprXtFfXddg99_AHmWrAWFDQhzYBQ&hash=270ab93c90bb798baa272636891046816fa6684736f7c8581c17eac1b4d8748a",
        id: 317014717
      },
      Daniil: {
        initData:
          "query_id=AAFRBOcZAAAAAFEE5xkuX_LT&user=%7B%22id%22%3A434570321%2C%22first_name%22%3A%22Daniil%22%2C%22last_name%22%3A%22%22%2C%22username%22%3A%22daniilkhlyvniuk%22%2C%22language_code%22%3A%22en%22%2C%22is_premium%22%3Atrue%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2F3jBxkrNIREzdjaWDpEtNItoTBVzD5_xFAWzfuWquGvo.svg%22%7D&auth_date=1733850482&signature=IL-r_xcgPtrB8XPZVBbcad2JqewjkkknShLVXyap1HJABkO8PI4d3CZzXFhcAaic-dok3Iu0D3ts4vai90BbDA&hash=a5fc779b72786080cf438498b881ce6abdf639023870a9ef54e2728b1cffc06b",
        id: 434570321
      },
      Daniil_stage: {
        initData:
          "query_id=AAFRBOcZAAAAAFEE5xnOw2dl&user=%7B%22id%22%3A434570321%2C%22first_name%22%3A%22Daniil%22%2C%22last_name%22%3A%22%22%2C%22language_code%22%3A%22en%22%2C%22is_premium%22%3Atrue%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2F3jBxkrNIREzdjaWDpEtNItoTBVzD5_xFAWzfuWquGvo.svg%22%7D&auth_date=1756033998&signature=JPm6waAIeRBfmgocyxwTNNdzKiJMmljlYjNJLUbsZlkXm7sK_VYm_1IP3DC4aKNnXlrk1xTl124IgKFvhb8-AA&hash=2e4608accb7c23eced993062f1afe9011f8d4821cf30c859dfa2ff877f1c0fd2",
        id: 434570321
      },
      Alex: {
        initData:
          "query_id=AAG9QuUSAAAAAL1C5RJdGL5g&user=%7B%22id%22%3A317014717%2C%22first_name%22%3A%22Alex%22%2C%22last_name%22%3A%22%22%2C%22username%22%3A%22alexc0re%22%2C%22language_code%22%3A%22uk%22%2C%22is_premium%22%3Atrue%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2F5tWNWjzkxjrj_pNdz2bf7lmAyPzrChE9NIIl4JVFLDg.svg%22%7D&auth_date=1733748147&signature=KCd1-TJ-jNP2cmGZmaK239ciCQqF9RMcgpNb1THusKK04-2AD5QXgujDJh_yYXpkpHs_k9D5eNq8UCoikq1MDg&hash=c7af6a0182791074cc508a153e070940a04040a63ba9d3720e7472f841bfa674",
        id: 317014717
      },
      Andrew: {
        id: "596824812",
        initData:
          "query_id=AAHs0pIjAAAAAOzSkiNVj2kn&user=%7B%22id%22%3A596824812%2C%22first_name%22%3A%22Andrew%22%2C%22last_name%22%3A%22%22%2C%22username%22%3A%22AndrewPanchenko%22%2C%22language_code%22%3A%22ru%22%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2FOlfP8tQ3EnmJ7IAk5_jr1eBARTs5l7qWGUW-eGoqaA4.svg%22%7D&auth_date=1738583743&signature=SdafDGIwfzXnC4r4s2C5KlLTWaLUhbfUaMs0RFe5WFVj9lJJ0RRPrOlnqdjR4IiD_gOTAcvgCKwmuRte0JiDAA&hash=720f3bfda098acb8f37852ef1923ed412c8a6cce532d1ca075f9be7f790d8353",
        photo_url:
          "https://t.me/i/userpic/320/OlfP8tQ3EnmJ7IAk5_jr1eBARTs5l7qWGUW-eGoqaA4.svg",
        timeZone: "Europe/Kiev"
      },
      Yellow_DEV: {
        id: "787382190",
        initData:
          "query_id=AAGuf-4uAAAAAK5_7i5SGKlo&user=%7B%22id%22%3A787382190%2C%22first_name%22%3A%22Yellow%22%2C%22last_name%22%3A%22%22%2C%22username%22%3A%22Yellow10041%22%2C%22language_code%22%3A%22en%22%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2FvZpe5YZpq9TZD89JxV3hSkTq6mrvVLtVZA6Yy-L2ecg.svg%22%7D&auth_date=1748346566&signature=WeOFdFHQ_A_5ygHdmy8zSWxM0MxKMOWkHAptXxxfTheTg5x8gPjFxmxUgSCIuOB-Bql59_IqV7bsE4eZURBAAw&hash=a13292f6dc444f64382d6943aa3e16c1455f8ab9236abe35dded7fac6783ea41",
        photo_url:
          "https://t.me/i/userpic/320/vZpe5YZpq9TZD89JxV3hSkTq6mrvVLtVZA6Yy-L2ecg.svg",
        timeZone: "Europe/Kiev"
      },
      Inovdev_DEV: {
        id: "7902755032",
        initData:
          "user=%7B%22id%22%3A7902755032%2C%22first_name%22%3A%22Innovation%22%2C%22last_name%22%3A%22Dev%22%2C%22username%22%3A%22inovdev%22%2C%22language_code%22%3A%22en%22%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2F2e9osVPDYZWE8u3tzwh-nx6O14cW-1XzqBqMxyNx3r2eCUE0TSYjW1F1TT2T-ExC.svg%22%7D&chat_instance=-8870392439738349317&chat_type=sender&start_param=ref_WEQPGK932F&auth_date=1750249928&signature=NviIwo9LBQxXgmZE9kFXkueJhOb0DdmJlnWfi-P5-sJAu2ZeA5tBiPUBp7v3Y6FloBK-qvmVuYFeIVe0TFisAg&hash=e4400f6f590f63f3b5ab9ee93a19ccacc259f533bdc91494550ad42a215527d9",
        photo_url:
          "https://t.me/i/userpic/320/2e9osVPDYZWE8u3tzwh-nx6O14cW-1XzqBqMxyNx3r2eCUE0TSYjW1F1TT2T-ExC.svg",
        timeZone: "Europe/Kiev"
      },
      Yellow_STAGE: {
        initData:
          "query_id=AAGuf-4uAAAAAK5_7i5eOQ7H&user=%7B%22id%22%3A787382190%2C%22first_name%22%3A%22Yellow%22%2C%22last_name%22%3A%22%22%2C%22username%22%3A%22Yellow10041%22%2C%22language_code%22%3A%22en%22%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2FvZpe5YZpq9TZD89JxV3hSkTq6mrvVLtVZA6Yy-L2ecg.svg%22%7D&auth_date=1766422921&signature=1QT58IyLFS1eoCDLhKLt6-LKfHOM1IS5U0kUkRpuRlaKVuAs84nuuBdUGBbK8OqdvF2adOqtTE0SOvnCzhB2Bg&hash=b0cb20407c58e1f327b26090c7c912d5d2eae32f5da6c82054d6dfc9d67bc4db",
        id: "787382190",
        photo_url:
          "https://t.me/i/userpic/320/vZpe5YZpq9TZD89JxV3hSkTq6mrvVLtVZA6Yy-L2ecg.svg",
        timeZone: "Europe/Rome"
      },
      Nikita_DEV: {
        id: "8142295964",
        initData:
          "query_id=AAGck1FlAwAAAJyTUWU4FMm_&user=%7B%22id%22%3A8142295964%2C%22first_name%22%3A%22%D0%9D%D0%B8%D0%BA%D0%B8%D1%82%D0%B0%22%2C%22last_name%22%3A%22%22%2C%22username%22%3A%22nik_burm%22%2C%22language_code%22%3A%22uk%22%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2F8-_6ChUY-iesphcWSwQJWOSWNq4PYmaSvPHVP2TkKju4Fplbczc8u10hrvcyZz5v.svg%22%7D&auth_date=1757508713&signature=CnBTqGAKAfSB7uYDHn-sO3v0W5A9QL7GnIEPFdUQMti6FJ1iRZDt8GH2tG6XRqa0heYG1kfhpI9qoUpVe8VaCQ&hash=62191e1c2d4a52657e7052fc58d734129acde7d12fb36f17a79b4dbb9522f7df",
        photo_url:
          "https://t.me/i/userpic/320/8-_6ChUY-iesphcWSwQJWOSWNq4PYmaSvPHVP2TkKju4Fplbczc8u10hrvcyZz5v.svg",
        timeZone: "Europe/Kiev"
      }
    }
    window.Telegram.WebApp = {
      // @ts-ignore
      initData: USERS_DATA[USER].initData,
      version: "2.0",
      platform: "web",
      colorScheme: "light",
      themeParams: {},
      initDataUnsafe: {
        user: {
          // @ts-ignore
          id: USERS_DATA[USER].id,
          // @ts-ignore
          photo_url: USERS_DATA[USER].photo_url || ""
        }
      }
    } as any
  } else {
    safeInitTelegram()
  }
}
